// extracted by mini-css-extract-plugin
export default {"genre":"Genre_genre__Gdq8c","genre__title":"Genre_genre__title__kA+MU"};